/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Aggregated summary metrics for a time period
 */
export type ObservabilitySummary = {
  /**
   * Average tool latency in milliseconds
   */
  avgLatencyMs: number;
  /**
   * Average time to resolution in milliseconds
   */
  avgResolutionTimeMs: number;
  /**
   * Average session duration in milliseconds
   */
  avgSessionDurationMs: number;
  /**
   * Sum of cache creation input tokens
   */
  cacheCreationInputTokens: number;
  /**
   * Sum of cache read input tokens
   */
  cacheReadInputTokens: number;
  /**
   * Number of failed chat sessions
   */
  failedChats: number;
  /**
   * Number of failed tool calls
   */
  failedToolCalls: number;
  /**
   * Number of resolved chat sessions
   */
  resolvedChats: number;
  /**
   * Total number of chat sessions
   */
  totalChats: number;
  /**
   * Total cost of all requests
   */
  totalCost: number;
  /**
   * Sum of input tokens used
   */
  totalInputTokens: number;
  /**
   * Sum of output tokens used
   */
  totalOutputTokens: number;
  /**
   * Sum of all tokens used
   */
  totalTokens: number;
  /**
   * Total number of tool calls
   */
  totalToolCalls: number;
};

/** @internal */
export const ObservabilitySummary$inboundSchema: z.ZodMiniType<
  ObservabilitySummary,
  unknown
> = z.pipe(
  z.object({
    avg_latency_ms: z.number(),
    avg_resolution_time_ms: z.number(),
    avg_session_duration_ms: z.number(),
    cache_creation_input_tokens: z.int(),
    cache_read_input_tokens: z.int(),
    failed_chats: z.int(),
    failed_tool_calls: z.int(),
    resolved_chats: z.int(),
    total_chats: z.int(),
    total_cost: z.number(),
    total_input_tokens: z.int(),
    total_output_tokens: z.int(),
    total_tokens: z.int(),
    total_tool_calls: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "avg_latency_ms": "avgLatencyMs",
      "avg_resolution_time_ms": "avgResolutionTimeMs",
      "avg_session_duration_ms": "avgSessionDurationMs",
      "cache_creation_input_tokens": "cacheCreationInputTokens",
      "cache_read_input_tokens": "cacheReadInputTokens",
      "failed_chats": "failedChats",
      "failed_tool_calls": "failedToolCalls",
      "resolved_chats": "resolvedChats",
      "total_chats": "totalChats",
      "total_cost": "totalCost",
      "total_input_tokens": "totalInputTokens",
      "total_output_tokens": "totalOutputTokens",
      "total_tokens": "totalTokens",
      "total_tool_calls": "totalToolCalls",
    });
  }),
);

export function observabilitySummaryFromJSON(
  jsonString: string,
): SafeParseResult<ObservabilitySummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ObservabilitySummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ObservabilitySummary' from JSON`,
  );
}
